import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import {AvailableLangs} from './environments/environment.interface';
import dayjs from 'dayjs';

if (environment.production) {
	enableProdMode();
}

if (environment.defaultLang === AvailableLangs.da) dayjs.locale('da');

document.addEventListener('DOMContentLoaded', () => {
	platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
		if ('serviceWorker' in navigator && environment.production) {
			navigator.serviceWorker.register('/ngsw-worker.js');
		}
		// tslint:disable-next-line:no-console
	}).catch(err => console.error(err));
});
